import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f555f87a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "index",
  class: "index"
}
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!
  const _component_Statistical = _resolveComponent("Statistical")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_config_provider, {
      locale: $options.isEnglish ? $data.expand.EnLocale : $data.expand.locale
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_view)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["locale"]),
    _createVNode(_component_Statistical)
  ], 64 /* STABLE_FRAGMENT */))
}